import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ChannelInviteOnlyError extends CodedError {
  static get errorName() {
    return errorCodes.channelInviteOnlyError.code;
  }

  constructor(message: string = errorCodes.channelInviteOnlyError.message) {
    super(message);
    this.code = errorCodes.channelInviteOnlyError.code;
    this.message = `${message} ${errorCodes.channelInviteOnlyError.code}`;
    this.name = errorCodes.channelInviteOnlyError.name;
  }
}
